export class SmartcardAlreadyRegisteredError extends Error {
  constructor() {
    super("The provided smartcard is already registered.");
    this.name = "SmartcardAlreadyRegisteredError";
  }
}
